// Shared minimal MD renderer with XSS sanitization.
// Content comes from our AI (lesson plans, plant picks, water diagnoses) — still
// sanitized defensively before any dangerouslySetInnerHTML.
import DOMPurify from "dompurify";

const SANITIZE_CFG = {
    ALLOWED_TAGS: ["code", "strong", "em"],
    ALLOWED_ATTR: [],
};

const safe = (html) => DOMPurify.sanitize(html, SANITIZE_CFG);

export function MD({ text }) {
    if (!text) return null;
    const lines = text.split("\n");
    const out = [];
    let list = null;
    const flushList = () => {
        if (list) {
            out.push(
                <ul key={`ul-${out.length}`}>
                    {list.map((li, i) => (
                        <li
                            key={`li-${out.length}-${i}`}
                            dangerouslySetInnerHTML={{ __html: safe(inline(li)) }}
                        />
                    ))}
                </ul>,
            );
            list = null;
        }
    };
    const inline = (s) =>
        s
            .replace(/`([^`]+)`/g, "<code>$1</code>")
            .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    lines.forEach((raw, idx) => {
        const line = raw.replace(/\s+$/, "");
        if (line.startsWith("# ")) {
            flushList();
            out.push(<h1 key={idx}>{line.slice(2)}</h1>);
        } else if (line.startsWith("## ")) {
            flushList();
            out.push(<h2 key={idx}>{line.slice(3)}</h2>);
        } else if (line.startsWith("### ")) {
            flushList();
            out.push(<h3 key={idx}>{line.slice(4)}</h3>);
        } else if (/^[-*]\s+/.test(line)) {
            if (!list) list = [];
            list.push(line.replace(/^[-*]\s+/, ""));
        } else if (line.trim() === "") {
            flushList();
        } else {
            flushList();
            out.push(
                <p
                    key={idx}
                    dangerouslySetInnerHTML={{ __html: safe(inline(line)) }}
                />,
            );
        }
    });
    flushList();
    return <div className="md">{out}</div>;
}
